// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Zg9gd","requiredAsterisk":"Info_requiredAsterisk__jC76f"};